import { InputRule } from "@handlewithcare/prosemirror-inputrules";
import { type NodeType } from "prosemirror-model";
import { type EditorState } from "prosemirror-state";

// Matches GitHub blob URLs with optional protocol and line anchors
// Examples:
//  - https://github.com/org/repo/blob/refspec/path/to/file.ts#L3-L8
//  - http://github.com/org/repo/blob/refspec/path/to/file.ts#L10
//  - github.com/org/repo/blob/refspec/app/src/pages/404.tsx#L3-L8
// Capture groups:
// 1: protocol (optional)
// 2: owner
// 3: repo
// 4: refspec
// 5: file path
// 6: start line
// 7: optional end line
const githubBlobRegex =
	/(https?:\/\/)?(?:www\.)?github\.com\/([^/\s]+)\/([^/\s]+)\/blob\/([^\s#]+?)\/([^\s#]+?)(?:#L(\d+)(?:-L(\d+))?)?\s+$/;

export const linkCodeSnippetRule = (nodeType: NodeType): InputRule => {
	const matchHandler = function (
		state: EditorState,
		match: RegExpMatchArray,
		start: number,
		end: number
	) {
		const tr = state.tr;
		const matchedString = match[0];
		const trimmedMatchedString = matchedString.trim();

		if (matchedString === undefined) {
			return tr;
		}

		const owner = match[2];
		const repo = match[3];
		const refspec = match[4];
		const filePath = match[5];
		const startLineStr = match[6];
		const endLineStr = match[7];

		// Normalize URL to include protocol
		let fullUrl = trimmedMatchedString;
		if (!match[1]) {
			fullUrl = `https://${trimmedMatchedString}`;
		}

		const startLine = startLineStr ? parseInt(startLineStr, 10) : 0;
		const endLine = endLineStr ? parseInt(endLineStr, 10) : null;

		return tr.replaceWith(
			start,
			end,
			nodeType.create({
				url: fullUrl,
				owner,
				repo,
				refspec,
				filePath,
				startLine,
				endLine,
			})
		);
	};

	return new InputRule(githubBlobRegex, matchHandler);
};
